import "core-js/modules/es.symbol.description.js";
import { Modal } from '@isyc-react/design/bootstrap';
import { nsnewo } from "../../../../i18n/namespaces";
import React from 'react';
import { useTranslation } from 'react-i18next';
export const CardCourseModalComponent = props => {
  const {
    data,
    show,
    onClose
  } = props;
  const {
    t
  } = useTranslation(nsnewo.common);
  return /*#__PURE__*/React.createElement(Modal, {
    show: show,
    size: "lg",
    "aria-labelledby": "contained-modal-title-vcenter",
    centered: true,
    scrollable: true
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    className: "border-bottom-0 bg-white p-4"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "modal-title font-size-22 text-black"
  }, t('newo.modalCourseInfo.title')), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn-close me-1",
    "aria-label": t('newo.modalCourseInfo.close'),
    onClick: onClose
  })), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "p-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row m-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col px-5 pb-4"
  }, data.objective && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h2", {
    className: "text-primary fw-bold border-bottom p-1 border-primary"
  }, t('newo.modalCourseInfo.objectives')), /*#__PURE__*/React.createElement("p", null, data.objective)), data.description && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h2", {
    className: "text-primary fw-bold border-bottom p-1 border-primary"
  }, t('newo.modalCourseInfo.description')), /*#__PURE__*/React.createElement("p", null, data.description))))), /*#__PURE__*/React.createElement(Modal.Footer, {
    className: "d-flex justify-content-center py-4 mt-5 mt-lg-0"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-pill btn-primary border-2 px-5 font-size-16",
    onClick: onClose
  }, t('newo.modalCourseInfo.close'))));
};